import {Icon, IconProps} from '@chakra-ui/react';

export function ArrowIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="white" {...props}>
      <g clipPath="url(#clip0_3122_17908)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.4C17.302 2.4 21.6 6.69806 21.6 12C21.6 17.302 17.302 21.6 12 21.6C6.69806 21.6 2.4 17.302 2.4 12C2.4 6.69806 6.69806 2.4 12 2.4ZM24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
        />
        <path d="M13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071C11.9024 15.3166 11.9024 14.6834 12.2929 14.2929L13.5858 13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H13.5858L12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12C17 12.2652 16.8946 12.5196 16.7071 12.7071L13.7071 15.7071Z" />
      </g>
      <defs>
        <clipPath id="clip0_3122_17908">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}
